import { EventSearchFormsStore } from './../../service/event-search-forms.store';
import { LogService } from './../../../shared/log/log.service';
import { PredefinedSearchService } from './../../service/predefined-search.service';
import { Todolist } from '../../models/dashboard/agency-dashboard';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { MultiAgencyService } from './../../../shared/multi-agency/multi-agency.service';
import { MultiAgency } from './../../../shared/models/multi-agency';
import { MissingAgencyDashboardStore } from './../../service/missing-agency-dashboard.store';
import { CompletedUnpaidDashboardStore } from './../../service/completed-unpaid-dashboard.store';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { BulkAction } from '../../models/bulk-action';
import { BulkActionPopupComponent } from '../../bulk-action/bulk-action-popup/bulk-action-popup.component';
import { EventSearchText } from 'app/event/models/event-search-text';
import { EventSearchParametersStore } from 'app/event/service/event-search-parameters.store';

@Component({
  selector: 'pioneer-dashboard-to-do-card',
  templateUrl: './dashboard-to-do-card.component.html',
  styleUrls: ['./dashboard-to-do-card.component.css'],
})
export class DashboardToDoCardComponent implements OnInit {
  @ViewChild(BulkActionPopupComponent)
  public bulkActionPopup: BulkActionPopupComponent;

  @Input() todolist: Todolist[];

  showCompletedAndUnpaid: boolean;
  showMissingAgency: boolean;

  defaultAgency$: Observable<MultiAgency> =
    this.multiAgencyService.defaultAgency$;
  agencySubscription$: Subscription = new Subscription();

  searchText: string;

  constructor(
    private completedUnpaidDashboardStore: CompletedUnpaidDashboardStore,
    private missingAgencyDashboardStore: MissingAgencyDashboardStore,
    private multiAgencyService: MultiAgencyService,
    private logger: LogService,
    private eventSearchFormsStore: EventSearchFormsStore,
    private eventSearchParametersStore: EventSearchParametersStore,
    private predefinedSearchService: PredefinedSearchService
  ) {}

  ngOnInit() {
    this.showCompletedAndUnpaid = true;
    this.showMissingAgency = true;
    this.searchText = '';
    this.agencySubscription$ = this.defaultAgency$.subscribe(() => {
      this.completedUnpaidDashboardStore.loadTotals().subscribe();
      this.missingAgencyDashboardStore.loadTotals().subscribe();
    });

    this.completedUnpaidDashboardStore.showCard().subscribe((bool) => {
      this.showCompletedAndUnpaid = bool;
    });

    this.missingAgencyDashboardStore.showCard().subscribe((bool) => {
      this.showMissingAgency = bool;
    });
  }

  openBulkActionModal(action: BulkAction) {

    // this.eventSearchParametersStore.reset(false);
    this.bulkActionPopup.open(action);
  }

  closedBulkActionModal(event: any) {}

  launchEventListPage(statusCategory: any): void {

    this.eventSearchParametersStore.reset(false);

    let statusCode = '';
    let missingEmail = false;
    switch (statusCategory) {
      case 'Review Rejected Payment Requests':
        statusCode = 'rejectedPaymentRequests';
        break;
      case 'Request Payments':
        statusCode = 'requestPayments';
        break;
      case 'Add Missing Payment Items':
        statusCode = 'missingPaymentItems';
        break;
      case 'Add Missing Vendor Contact Email':
        missingEmail = true;
        break;

      default:
        break;
    }
    if (missingEmail) {
      this.predefinedSearchService.missingVendorContactEmailSearch();
    } else {
      this.predefinedSearchService.paymentStatusSearch(statusCode);
    }

  }

  get BulkAction() {
    return BulkAction;
  }

  addSearchText(): void {
    let models = {searchText: this.searchText};
    const eventSearchText = new EventSearchText(models);
    this.logger.info(`addSearchText: ${JSON.stringify(models)}`);

    if (!eventSearchText.searchText) {
      return;
    }

    this.eventSearchParametersStore.reset(true);

    this.eventSearchFormsStore.searchFromSearchText(eventSearchText);
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/agency-dashboard/dashboard-to-do-card/dashboard-to-do-card.component.ts